import BaseReportParams from './baseReportParams';

export default class CurrVsPrevReportParams extends BaseReportParams {}
